export default __webpack_public_path__ + "static/media/feb-23.9930021d.jpg";